(function(){
"use strict";
var root=document.getElementById("demaBuy");if(!root)return;
function $(id){return document.getElementById(id)}
var RM=matchMedia("(prefers-reduced-motion: reduce)").matches;
var VAR=[],META={};
try{VAR=JSON.parse($("demaVariants").textContent)}catch(e){}
try{META=JSON.parse($("demaMeta").textContent)||{}}catch(e){}
var LIST=META.listino||{};
if(typeof LIST==="string"){try{LIST=JSON.parse(LIST)}catch(e){LIST={}}}

var imgs=[].slice.call($("shot").querySelectorAll("img"));
var dots=[].slice.call($("dots").children);
dots.forEach(function(d,i){d.addEventListener("click",function(){
 imgs.forEach(function(m,k){m.classList.toggle("act",k===i)});
 dots.forEach(function(x,k){x.setAttribute("aria-pressed",k===i)});
})});

var GTXT={
 "buono":["Segni ben visibili","La scocca pu\u00f2 presentare graffi profondi e piccole ammaccature sui bordi. Il vetro pu\u00f2 avere segni leggeri, mai crepe.",7],
 "ottimo":["Micro-graffi su scocca e display","Visibili solo da vicino e sotto luce diretta. Nulla di percettibile durante l'uso normale.",3],
 "premium":["Nessun segno","Scocca e vetro senza alcun segno, sotto qualsiasi luce. Batteria nuova o sopra il 95%, 24 mesi di garanzia.",0],
 "pari al nuovo":["Nessun segno","Scocca e vetro senza alcun segno, sotto qualsiasi luce. Batteria nuova o sopra il 95%, 24 mesi di garanzia.",0]
};
var SEGNI=[[11,26,7],[46,46,6],[16,74,9],[49,94,6],[12,108,5],[43,21,5],[27,112,7]];
var marks=$("marks"),lines=[];
if(marks){
 marks.innerHTML=SEGNI.map(function(m){return '<line x1="'+m[0]+'" y1="'+m[1]+'" x2="'+(m[0]+m[2])+'" y2="'+(m[1]+m[2]*.5)+'" stroke="#A5A7BE" stroke-width="1" stroke-linecap="round" opacity="0" style="transition:opacity .42s"/>'}).join("");
 lines=[].slice.call(marks.querySelectorAll("line"));
}
function polish(keep){
 var po=$("polish");if(!po)return;
 var t0=performance.now();po.setAttribute("opacity","1");
 requestAnimationFrame(function st(t){
  var k=Math.min(1,(t-t0)/1250),y=-28+k*152;
  po.setAttribute("y",y);
  lines.forEach(function(l,i){if(i>=keep&&SEGNI[i][1]<y+12)l.style.opacity="0"});
  k<1?requestAnimationFrame(st):po.setAttribute("opacity","0");
 });
}

var sel={};
[].forEach.call(root.querySelectorAll("[data-opt]"),function(b){
 if(b.getAttribute("aria-pressed")==="true")sel[b.dataset.opt]=b.dataset.val;
});
function findVariant(o){
 for(var i=0;i<VAR.length;i++){
  var v=VAR[i];
  if((!o["1"]||v.option1===o["1"])&&(!o["2"]||v.option2===o["2"])&&(!o["3"]||v.option3===o["3"]))return v;
 }
 return null;
}
function money(c){return "\u20ac"+(c/100).toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
var first=true;
function render(){
 [].forEach.call(root.querySelectorAll("[data-opt]"),function(b){
  var probe={};for(var k in sel)probe[k]=sel[k];
  probe[b.dataset.opt]=b.dataset.val;
  var v=findVariant(probe);
  var sm=b.querySelector("small");
  if(sm)sm.textContent=v?money(v.price):"";
  if(b.classList.contains("opt"))b.disabled=!v||!v.available;
  b.setAttribute("aria-pressed",sel[b.dataset.opt]===b.dataset.val);
 });
 var cur=findVariant(sel);
 if(cur){
  $("demaVariantId").value=cur.id;
  $("demaAdd").disabled=!cur.available;
  $("demaAdd").textContent=cur.available?"Aggiungi al carrello":"Non disponibile";
  var bv=$("demaBarVar");if(bv)bv.textContent=cur.title.replace(/ \/ /g," \u00b7 ");
  var st=$("demaStock");if(st)st.style.display=cur.available?"":"none";
  var capKey=null;
  for(var k in sel){ if(/\d+\s*(GB|TB)/i.test(sel[k]))capKey=sel[k]; }
  var L=LIST&&capKey?LIST[capKey]:null;
  if(L){
   $("wasN").textContent="\u20ac"+L;$("wasBox").hidden=false;
   $("save").textContent="Risparmi \u20ac"+(L-Math.round(cur.price/100));$("save").hidden=false;
  }else{$("wasBox").hidden=true;$("save").hidden=true}
  /* conserva i parametri esistenti, incluso preview_theme_id */
  try{
   var u=new URL(location.href);
   u.searchParams.set("variant",cur.id);
   history.replaceState({},"",u.pathname+u.search+u.hash);
  }catch(e){}
  if(cur.featured_image&&cur.featured_image.src){
   var want=cur.featured_image.src.split("?")[0].split("/").pop().split(".")[0];
   imgs.forEach(function(m,k){ if(m.src.indexOf(want)>-1){ imgs.forEach(function(z,j){z.classList.toggle("act",j===k)}); dots.forEach(function(z,j){z.setAttribute("aria-pressed",j===k)}); } });
  }
 }
 var gv=null;
 for(var k2 in sel){ var lv=(sel[k2]||"").toLowerCase(); if(GTXT[lv])gv=lv; }
 var seg=$("gseg");
 if(gv&&seg){
  var g=GTXT[gv],pr=(gv==="premium"||gv==="pari al nuovo");
  $("ghead").textContent=g[0];$("gtext").textContent=g[1];
  var vis=lines.filter(function(l){return l.style.opacity==="1"}).length;
  if(!first&&!RM&&g[2]<vis)polish(g[2]);
  else lines.forEach(function(l,k3){l.style.transitionDelay=(k3*55)+"ms";l.style.opacity=k3<g[2]?"1":"0"});
  var bs=[].slice.call(seg.querySelectorAll("button"));
  var act=null;bs.forEach(function(b){if(b.dataset.val.toLowerCase()===gv)act=b});
  if(act){var r=act.getBoundingClientRect(),w=seg.getBoundingClientRect();
   $("pill").style.width=r.width+"px";$("pill").style.transform="translateX("+(r.left-w.left-3)+"px)"}
  $("grade").classList.toggle("pr",pr);
  document.body.classList.toggle("pr",pr);
  if($("pb")){$("pb").setAttribute("fill",pr?"#251C0C":"#E6EBFA");$("pb").setAttribute("stroke",pr?"#C9992C":"#C9D4EE")}
  if($("ps"))$("ps").setAttribute("fill",pr?"#090701":"#ffffff");
  $("gbadge").style.display=pr?"inline-block":"none";
  $("warm").textContent=(pr?"24":"12")+" mesi di garanzia";
  if(pr){
   $("gbadge").style.animation="none";void $("gbadge").offsetWidth;
   $("gbadge").style.animation="pop .58s cubic-bezier(.22,.9,.28,1) .2s both";
   if(!first&&!RM){var bl=$("blade");bl.style.animation="none";void bl.offsetWidth;bl.style.animation="blade 1.55s cubic-bezier(.35,.02,.28,1) 1 both"}
  }else if($("blade"))$("blade").style.animation="none";
 }
 first=false;
 if(window.__demaSyncPrice)window.__demaSyncPrice();
}
[].forEach.call(root.querySelectorAll("[data-opt]"),function(b){
 b.addEventListener("click",function(){
  if(b.disabled)return;
  sel[b.dataset.opt]=b.dataset.val;
  var cn=$("cn");if(cn&&b.classList.contains("sw"))cn.textContent=b.dataset.val;
  render();
 });
});
addEventListener("resize",function(){render()});
render();

(function(){
 var el=$("deliv");if(!el)return;
 var d=new Date(),add=0,biz=0;
 while(biz<6){add++;var t=new Date(d);t.setDate(d.getDate()+add);if(t.getDay()!==0&&t.getDay()!==6)biz++}
 var end=new Date(d);end.setDate(d.getDate()+add);
 var M=["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
 el.textContent="Consegna prevista entro il "+end.getDate()+" "+M[end.getMonth()];
})();

(function(){
 var bar=$("demaBar"),form=document.querySelector(".dema-form");
 if(!bar||!form)return;
 new IntersectionObserver(function(es){bar.classList.toggle("on",!es[0].isIntersecting)},{rootMargin:"-100px 0px 0px 0px"}).observe(form);
 $("demaBarGo").addEventListener("click",function(){
  form.scrollIntoView({behavior:"smooth",block:"center"});
  setTimeout(function(){var b=$("demaAdd");if(b)b.focus()},420);
 });
})();
})();
